// extracted by mini-css-extract-plugin
export default {"page":"Page-module__page___LVMNK"};